import { memo } from "react";
import { classNames } from "@circle-react/helpers/twMergeWithCN";

export interface FloatingDropAreaProps {
  isOver: boolean;
  orientation: "horizontal" | "vertical";
}

export const FloatingDropArea = memo(
  ({ isOver, orientation }: FloatingDropAreaProps) => {
    const isVertical = orientation === "vertical";

    return (
      <div
        className={classNames(
          "absolute transition-all",
          {
            // Horizontal layout - centered horizontally
            "top-1/2 w-full -translate-y-1/2": !isVertical,
            // Vertical layout - centered vertically
            "left-0 h-full": isVertical,
          },
          {
            // Horizontal active state - just a line
            "h-[2px] bg-blue-500": isOver && !isVertical,
            // Vertical active state - just a line
            "w-[2px] bg-blue-500": isOver && isVertical,
          },
        )}
        data-testid="builder-ui-floating-drop-area"
      />
    );
  },
);

FloatingDropArea.displayName = "FloatingDropArea";
